// Centralized API name mapping for use across SwaggerView, APIDocsTemplate, etc.

export const apiNames = {
  "nio-autocoder": "NIO Autocoder",
  "oamd": "AMD Platform APIs",
  "mvps-external-api": "MVPS Reports External API",
  "amdp-api": "AMDP API",
  "ews-admincodes-api": "Admin Codes API (EWS)",
  "ews-calendar-api": "Calendar API (EWS)",
  "ews-email-api": "Email API (EWS)",
  "ews-lookup-api": "Lookup API (EWS)",
  "ews-person-api": "Person API (EWS)",
  "data-scanner-api": "Data Scanner API",
  "haic-cdi-api": "HAIC CDI API"
};
